export default __webpack_public_path__ + "static/media/text_bubble_03.ae9ea53c.png";